var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _c("Multiselect", {
        ref: "multiselect",
        attrs: {
          id: _vm.id,
          options: _vm.relevantOptions,
          "track-by": "id",
          label: "label",
          placeholder: _vm.placeholder,
          "show-labels": false,
          "close-on-select": _vm.closeOnSelect,
          taggable: false,
          multiple: _vm.multiple,
          "internal-search": !_vm.searchType
        },
        on: {
          "search-change": _vm.onSearchChange,
          select: _vm.onChange,
          remove: _vm.onRemove
        },
        scopedSlots: _vm._u([
          {
            key: "noResult",
            fn: function() {
              return [_vm._v(_vm._s(_vm.noResultsText))]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.selection,
          callback: function($$v) {
            _vm.selection = $$v
          },
          expression: "selection"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }